import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoDblClickDirective } from './directives/no-dbl-click.directive';
import { LoadingButtonDirective } from './directives/loading-button.directive';
import { GmapComponent } from './components/gmap/gmap.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BlockUIModule } from 'primeng/blockui';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { NoBlankSpacesPipe } from './pipes/no-blank-spaces.pipe';
import { StringPipe } from './pipes/string.pipe';
import { PhotoPipe } from './pipes/photo.pipe';
import { UserPipe } from './pipes/user.pipe';
import { UserActionDirective } from './directives/userAction.directive';

@NgModule({
  declarations: [
    NoDblClickDirective,
    LoadingButtonDirective,
    NoBlankSpacesPipe,
    StringPipe,
    PhotoPipe,
    UserPipe,
    UserActionDirective,
    GmapComponent
  ],
  imports: [CommonModule, ToastModule, ConfirmDialogModule, BlockUIModule, CurrencyMaskModule, GoogleMapsModule],
  exports: [
    NoDblClickDirective,
    CurrencyMaskModule,
    LoadingButtonDirective,
    ToastModule,
    ConfirmDialogModule,
    BlockUIModule,
    NoBlankSpacesPipe,
    StringPipe,
    PhotoPipe,
    UserPipe,
    UserActionDirective,
    GmapComponent
  ]
})
export class SharedModule {}
